var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.modal
        ? _c("modal-assinatura", {
            attrs: {
              titulo: "Assinar documento",
              texto:
                "Para realizar a assinatura do documento é necessário informar a senha do seu certificado digital. Ao finalizar, o documento será assinado."
            },
            on: {
              closeModal: function($event) {
                return _vm.closeModal()
              },
              callbackSucesso: _vm.callbackModalAssinatura
            }
          })
        : _vm._e(),
      _c("divider", {
        staticClass: "text-container",
        attrs: { label: "Assinar documento" }
      }),
      _c(
        "validation-observer",
        { ref: "observer", attrs: { tag: "form" } },
        [
          _c("validation-provider", {
            attrs: { rules: "required" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-row",
                      { staticClass: "row" },
                      [
                        _c(
                          "el-col",
                          {
                            staticClass: "container-input",
                            attrs: { span: 8 }
                          },
                          [
                            _c("app-label", {
                              attrs: {
                                label: "Selecione o Responsável:",
                                required: true
                              }
                            }),
                            _c(
                              "el-select",
                              {
                                staticClass: "input select",
                                class: { erro: errors.length },
                                attrs: {
                                  filterable: "filterable",
                                  "filter-method": _vm.filtrarResponsaveis,
                                  placeholder: "Selecione",
                                  "value-key": "id",
                                  name: "Resposavel"
                                },
                                nativeOn: {
                                  paste: function($event) {
                                    return _vm.onPaste($event)
                                  }
                                },
                                model: {
                                  value: _vm.responsavel,
                                  callback: function($$v) {
                                    _vm.responsavel = $$v
                                  },
                                  expression: "responsavel"
                                }
                              },
                              _vm._l(_vm.responsaveisFiltrados, function(item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: {
                                    label: item.usuario.pessoa.nomeRazaoSocial,
                                    value: item
                                  }
                                })
                              }),
                              1
                            ),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("visualizar-documentos", {
        attrs: { documento: _vm.documentoAssinatura, bytes: _vm.bytes }
      }),
      _c(
        "div",
        { staticClass: "buttons" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "default", name: "voltar" },
              on: { click: _vm.goToListagem }
            },
            [
              _c("span", { staticClass: "center" }, [
                _c("i", { staticClass: "fa fa-chevron-left" }),
                _c("b", [_vm._v("  Voltar")])
              ])
            ]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", name: "assinar" },
              on: { click: _vm.openModal }
            },
            [
              _c("span", { staticClass: "center" }, [
                _c("i", { staticClass: "fa fa-pencil-alt" }),
                _c("b", [_vm._v("  Assinar documento")])
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a414ae6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a414ae6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/assinatura/AssinaturaDocumento.vue
// module id = null
// module chunks = 